import { ProductAttributeSortInput } from '~/modules/GraphQL/types';
import { ref } from "@nuxtjs/composition-api";
export function createProductAttributeSortInput(sortData: string): ProductAttributeSortInput {
  const sortDataArray = sortData.split(/_/gi);
  const baseData = ref([]);
  if (sortDataArray.length > 2) {
    const sortLabel = sortDataArray.slice(0, -1).join('_');
    const sortValue = sortDataArray[sortDataArray.length -1];
    baseData.value.push(sortLabel);
    baseData.value.push(sortValue);
  } else {
    baseData.value = sortDataArray;
  }
  return baseData.value.length > 0 ? Object.fromEntries([baseData.value]) : {};
}
